import React, { useRef } from "react";
import { Search, X } from "lucide-react";
import { cn } from "./ui/utils";
import { useTranslation } from "react-i18next";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  autoFocus?: boolean;
  className?: string;
}

export function SearchInput({
  value,
  onChange,
  placeholder,
  autoFocus,
  className,
}: SearchInputProps) {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={cn("relative", className)}>
      <Search
        size={18}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
      />
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder ?? t("nav.search")}
        autoFocus={autoFocus}
        className="w-full h-10 pl-10 pr-10 rounded-xl bg-gray-100/80 text-base text-gray-900 placeholder:text-gray-400 outline-none focus:ring-2 focus:ring-indigo-200 transition-shadow"
      />
      {value && (
        <button
          type="button"
          onClick={() => {
            onChange("");
            inputRef.current?.focus();
          }}
          className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-gray-300 flex items-center justify-center"
        >
          <X size={12} className="text-white" />
        </button>
      )}
    </div>
  );
}
